export function toWireStatements(statements) {
    return statements.map((s) => ({ sql: s.sql, params: s.params ?? [] }));
}
//# sourceMappingURL=opfsProtocol.js.map